import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-caption mb-4" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-center mb-2"
}
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = {
  key: 1,
  class: "d-flex align-center mb-2"
}
const _hoisted_9 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_file_upload = _resolveComponent("v-file-upload")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_FocusLock, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { id: "focusLockDialogForm" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { class: "mb-5" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { justify: "left" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "6",
                            class: "pa-5"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_file_upload, {
                                modelValue: _ctx.selectedFile,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFile) = $event)),
                                accept: "*",
                                "show-size": true,
                                clearable: "",
                                "browse-text": _ctx.$t('lieferanten.dokument.upload.durchsuchen'),
                                "divider-text": _ctx.$t('lieferanten.dokument.upload.divider'),
                                icon: "mdi-upload",
                                title: _ctx.$t('lieferanten.dokument.upload.draganddrop'),
                                counter: true,
                                disabled: false,
                                loading: false,
                                multiple: false,
                                class: "mb-4",
                                style: {"max-width":"90%"},
                                height: "320px"
                              }, null, 8, ["modelValue", "browse-text", "divider-text", "title"]),
                              _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("i", null, _toDisplayString(_ctx.$t('upload.remarks')), 1),
                                _cache[5] || (_cache[5] = _createTextVNode()),
                                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("i", null, _toDisplayString(_ctx.allowedFileTypes.join(', ')), 1)
                              ]),
                              _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('lieferanten.dokument.title')), 1),
                              _createVNode(_component_Field, {
                                name: "selectedTitle",
                                rules: "required|max:255"
                              }, {
                                default: _withCtx(({ errors, field }) => [
                                  _createVNode(_component_v_text_field, _mergeProps(field, {
                                    modelValue: _ctx.selectedTitle,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTitle) = $event)),
                                    "error-messages": errors,
                                    "hide-details": "",
                                    class: "mb-4"
                                  }), null, 16, ["modelValue", "error-messages"])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('lieferanten.dokument.kategorie')), 1),
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.selectedKategorie,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedKategorie) = $event)),
                                items: _ctx.dokumentKategorien,
                                "hide-details": "",
                                class: "mb-4",
                                "menu-props": { attach: '#focusLockDialogForm' }
                              }, null, 8, ["modelValue", "items"]),
                              (_ctx.selectedKategorie === 'vertrag' || _ctx.selectedKategorie === 'individuell')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('lieferanten.dokument.selectLieferant')), 1),
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _ctx.selectedLieferantenNummer,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedLieferantenNummer) = $event)),
                                      placeholder: _ctx.$t('lieferanten.dokument.lieferantennummer'),
                                      type: "number",
                                      counter: "3",
                                      class: "mb-4",
                                      rules: [(v) => !v || (v >= 0 && v <= 999) || _ctx.$t('lieferanten.dokument.lieferantennummer.error')]
                                    }, null, 8, ["modelValue", "placeholder", "rules"])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "6",
                            class: "pa-5",
                            "align-self": "end"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.getLieferantDetails)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_v_card, {
                                      variant: "outlined",
                                      class: "pa-3"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.getLieferantDetails.firma)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                              _createVNode(_component_v_icon, { start: "" }, {
                                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                  _createTextVNode("mdi-office-building")
                                                ])),
                                                _: 1
                                              }),
                                              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getLieferantDetails.firma), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.getLieferantDetails.lieferantenNummer)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                              _createVNode(_component_v_icon, { start: "" }, {
                                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                  _createTextVNode("mdi-tag")
                                                ])),
                                                _: 1
                                              }),
                                              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('lieferanten.dokument.lieferantennummer')) + ": " + _toDisplayString(_ctx.getLieferantDetails.lieferantenNummer), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        sm: "6",
                        class: "d-flex"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            disabled: !_ctx.canUpload,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.uploadDokumenteWrapper(_ctx.getLieferantDetails?.teilnehmerId)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { start: "" }, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createTextVNode("mdi-upload")
                                ])),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('lieferanten.dokument.hochladen')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}